module.exports = __webpack_public_path__ + "img/20.5255e89c.png";